import React from 'react';
import { Button, Flex, Link, theme, Text } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import { centsToDollars } from '../../utils/helpers';
import { DecisioningStateType } from '../../containers/BillingProfiles/CreditTermsApplication/DecisioningStates/decisioningStatesConfig';
import { WWW_ORIGIN } from '../../config';

interface Props {
  decision: DecisioningStateType;
  // handleActionStep: (action: string) => void; Commenting out until we decide where this goes
  email?: string;
  terms?: {
    approvedLimit: number;
    netTerms: string;
  };
}

const DecisioningTemplate = ({ decision, email, terms }: Props) => {
  const checkoutQuoteId = window.localStorage.getItem('checkoutQuoteId');
  return (
    <Flex alignItems="center" flexDirection="column">
      <img
        src={decision.image}
        alt={decision.imageAltText}
        css={css`
          max-height: 300px;
        `}
      />
      <Text
        kind="subpage-title"
        color={
          decision.type === 'approvedState'
            ? theme.colors.greens[100]
            : theme.colors.darkBlues[90]
        }
        margin="16px 0px"
      >
        {decision.type === 'approvedState' && (
          <i
            className="fa-solid fa-check"
            css={css`
              margin-right: 10px;
            `}
          />
        )}
        {decision.headline}
      </Text>
      {decision.type === 'approvedState' && (
        <Text
          kind="panel-title"
          display="block"
          marginBottom="16px"
          fontWeight={theme.fontWeights.semibold}
        >
          {terms?.netTerms} Terms up to {centsToDollars(terms?.approvedLimit)}
        </Text>
      )}

      <Text kind="body" textAlign="initial">
        {decision.text}
        {/* If the user gets an error, we display a link to mail to our suport */}
        {/* If the user gets auto approved, display support email to add authorized users */}
        {(decision.type === 'errorState' ||
          decision.type === 'approvedState') && (
          <Link href="mailto:support@xometry.com">support@xometry.com</Link>
        )}
        {/* If the user gets a pedning or pending declined, we display the email Xometry will reach out to for further instructions */}
        {(decision.type === 'pendingDeclinedState' ||
          decision.type === 'pendingState') && <Text>{email}</Text>}
        {decision?.text2}
        {decision.type === 'approvedState' && (
          <Link
            target="_blank"
            href="https://support.xometry.com/hc/en-us/articles/360059449413"
          >
            Learn more about Xometry Terms.
          </Link>
        )}
      </Text>
      {/* For auto approvals generated from a user through the checkout flow, have a button that will take them back that specific checkout */}
      {decision.type === 'approvedState' && checkoutQuoteId && (
        <Link href={`${WWW_ORIGIN}/checkout/${checkoutQuoteId}`}>
          <Button
            kind={theme.kind.primary}
            scale={theme.scale.large}
            alignSelf="center"
            marginTop={theme.space[6]}
            onClick={() => {
              if (window.analytics) {
                window.analytics.track('Auto Decision CTA Clicked', {
                  Decision: 'Approved',
                });
              }
              window.localStorage.removeItem('checkoutQuoteId');
            }}
          >
            {decision.buttonText}
          </Button>
        </Link>
      )}
    </Flex>
  );
};

export default DecisioningTemplate;
